export const pgTimezoneMatch = /ZULU|YEKT|YEKST|YAPT|YAKT|YAKST|XJT|WGT|WGST|WFT|WETDST|WET|WDT|WAT|WAST|WAKT|WADT|VUT|VOLT|VLAT|VLAST|VET|UZT|UZST|UYT|UYST|UTC|UT|ULAT|ULAST|UCT|TVT|TRUT|TOT|TMT|TKT|TJT|TFT|TAHT|SGT|SCT|SAST|SADT|RET|PYT|PYST|PWT|PST|PONT|PMST|PMDT|PKT|PKST|PHT|PGT|PETT|PETST|PET|PDT|OMST|OMSST|NZT|NZST|NZDT|NUT|NST|NPT|NOVT|NOVST|NFT|NDT|MYT|MVT|MUT|MUST|MST|MSK|MSD|MPT|MMT|MHT|MEZ|METDST|MET|MESZ|MEST|MDT|MAWT|MART|MAGT|MAGST|LKT|LINT|LIGT|LHST|LHDT|KST|KRAT|KRAST|KOST|KGT|KGST|KDT|JST|JAYT|IST|IRT|IRKT|IRKST|IOT|IDT|ICT|HST|HKT|GYT|GMT|GILT|GFT|GET|GEST|GAMT|GALT|FNT|FNST|FKT|FKST|FJT|FJST|FET|EST|EGT|EGST|EETDST|EET|EEST|EDT|EAT|EAST|EASST|DDUT|DAVT|CXT|CST|COT|CLT|CLST|CKT|CHUT|CHAST|CHADT|CETDST|CET|CEST|CDT|CCT|CAST|CADT|BTT|BST|BRT|BRST|BRA|BOT|BORT|BNT|BDT|BDST|AZT|AZST|AZOT|AZOST|AWST|AWSST|AST|ART|ARST|ANAT|ANAST|AMT|AMST|ALMT|ALMST|AKST|AKDT|AFT|AEST|AESST|AEDT|ADT|ACWST|ACT|ACST|ACSST|ACDT$/;
export const pgTimezoneAbbrevs = {
    ZULU: 0,
    YEKT: 18000,
    YEKST: 21600,
    YAPT: 36000,
    YAKT: 32400,
    YAKST: 32400,
    XJT: 21600,
    WGT: -10800,
    WGST: -7200,
    WFT: 43200,
    WETDST: 3600,
    WET: 0,
    WDT: 32400,
    WAT: 3600,
    WAST: 25200,
    WAKT: 43200,
    WADT: 28800,
    VUT: 39600,
    VOLT: 10800,
    VLAT: 36000,
    VLAST: 36000,
    VET: -14400,
    UZT: 18000,
    UZST: 21600,
    UYT: -10800,
    UYST: -7200,
    UTC: 0,
    UT: 0,
    ULAT: 28800,
    ULAST: 32400,
    UCT: 0,
    TVT: 43200,
    TRUT: 36000,
    TOT: 46800,
    TMT: 18000,
    TKT: 46800,
    TJT: 18000,
    TFT: 18000,
    TAHT: -36000,
    SGT: 28800,
    SCT: 14400,
    SAST: 7200,
    SADT: 37800,
    RET: 14400,
    PYT: -14400,
    PYST: -10800,
    PWT: 32400,
    PST: -28800,
    PONT: 39600,
    PMST: -10800,
    PMDT: -7200,
    PKT: 18000,
    PKST: 21600,
    PHT: 28800,
    PGT: 36000,
    PETT: 43200,
    PETST: 43200,
    PET: -18000,
    PDT: -25200,
    OMST: 21600,
    OMSST: 21600,
    NZT: 43200,
    NZST: 43200,
    NZDT: 46800,
    NUT: -39600,
    NST: -12600,
    NPT: 20700,
    NOVT: 25200,
    NOVST: 25200,
    NFT: -12600,
    NDT: -9000,
    MYT: 28800,
    MVT: 18000,
    MUT: 14400,
    MUST: 18000,
    MST: -25200,
    MSK: 10800,
    MSD: 14400,
    MPT: 36000,
    MMT: 23400,
    MHT: 43200,
    MEZ: 3600,
    METDST: 7200,
    MET: 3600,
    MESZ: 7200,
    MEST: 7200,
    MDT: -21600,
    MAWT: 18000,
    MART: -34200,
    MAGT: 39600,
    MAGST: 39600,
    LKT: 19800,
    LINT: 50400,
    LIGT: 36000,
    LHST: 37800,
    LHDT: 37800,
    KST: 32400,
    KRAT: 25200,
    KRAST: 25200,
    KOST: 39600,
    KGT: 21600,
    KGST: 21600,
    KDT: 36000,
    JST: 32400,
    JAYT: 32400,
    IST: 7200,
    IRT: 12600,
    IRKT: 28800,
    IRKST: 28800,
    IOT: 21600,
    IDT: 10800,
    ICT: 25200,
    HST: -36000,
    HKT: 28800,
    GYT: -14400,
    GMT: 0,
    GILT: 43200,
    GFT: -10800,
    GET: 14400,
    GEST: 14400,
    GAMT: -32400,
    GALT: -21600,
    FNT: -7200,
    FNST: -3600,
    FKT: -10800,
    FKST: -10800,
    FJT: 43200,
    FJST: 46800,
    FET: 10800,
    EST: -18000,
    EGT: -3600,
    EGST: 0,
    EETDST: 10800,
    EET: 7200,
    EEST: 10800,
    EDT: -14400,
    EAT: 10800,
    EAST: -21600,
    EASST: -21600,
    DDUT: 36000,
    DAVT: 25200,
    CXT: 25200,
    CST: -21600,
    COT: -18000,
    CLT: -14400,
    CLST: -10800,
    CKT: -36000,
    CHUT: 36000,
    CHAST: 45900,
    CHADT: 49500,
    CETDST: 7200,
    CET: 3600,
    CEST: 7200,
    CDT: -18000,
    CCT: 28800,
    CAST: 34200,
    CADT: 37800,
    BTT: 21600,
    BST: 3600,
    BRT: -10800,
    BRST: -7200,
    BRA: -10800,
    BOT: -14400,
    BORT: 28800,
    BNT: 28800,
    BDT: 21600,
    BDST: 7200,
    AZT: 14400,
    AZST: 14400,
    AZOT: -3600,
    AZOST: 0,
    AWST: 28800,
    AWSST: 32400,
    AST: -14400,
    ART: -10800,
    ARST: -10800,
    ANAT: 43200,
    ANAST: 43200,
    AMT: -14400,
    AMST: 14400,
    ALMT: 21600,
    ALMST: 25200,
    AKST: -32400,
    AKDT: -28800,
    AFT: 16200,
    AEST: 36000,
    AESST: 39600,
    AEDT: 39600,
    ADT: -10800,
    ACWST: 31500,
    ACT: -18000,
    ACST: 34200,
    ACSST: 37800,
    ACDT: 37800,
};
//# sourceMappingURL=pgtime.js.map